import type { ExtraProfileField } from "@jti/fe-common";
import type { FormTarget, OrderAttribute } from "@jti/magento";

import { filterToVisibleAttributes } from "../filterToVisibleAttributes";
import { sortAttributes } from "../sortAttributes";

export const selectVisibleAttributes = (
  allMagentoDefinedAttributes: OrderAttribute[] | undefined,
  userProfileExtraAttributes: ExtraProfileField,
  target: FormTarget
): OrderAttribute[] => {
  if (!allMagentoDefinedAttributes || allMagentoDefinedAttributes.length === 0) return [];

  const visibleAttributes = filterToVisibleAttributes(allMagentoDefinedAttributes, userProfileExtraAttributes, target);

  if (!visibleAttributes.length) return [];

  const sortedVisibleAttributes = sortAttributes(visibleAttributes);

  return sortedVisibleAttributes;
};
